module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-mini-2-md-657a76d33e97d0f041c17c954eddce8e.png";